import { isActive } from "reducers/variables/helpers";
import { LOCAL_VARIABLE_SCOPE } from "constants/variables";
import memoize from "services/memoize";


/**
 * @param {Object} variable
 * @returns {String}
 */
export default function getVariableName(variable) {
  let { name } = variable;

  switch (name) {
    case "chatter_id":
      name = "Chatter ID";
      break;
    case "chatter_token":
      name = "Chatter Token";
      break;
    default:
      name = variable.displayName || name;
      break;
  }


  return name;
}

export const flattenVariables = variables => variables.valueSeq().toList().flatten(2);

/**
 * Returns an Immutable List of variable records based on specified scopes
 *
 * @param {Immutable.Map} variables
 * @param {Object} options
 * @param {Array.<String>} options.scopes
 * @param {String} options.responseId
 * @returns {Immutable.List}
*/
export const getVariables = memoize((
  variables, { scopes = null, responseId = null }
) => flattenVariables(variables)
  .filter(variable => (
    // Either no scopes specified, or the variable must match one of the scopes
    (!scopes || scopes.includes(variable.scope)) &&
    // Either no responseId specified,
    // or: either the variable is not local, or it is local and must have specified responseId
    (!responseId ||
      variable.scope !== LOCAL_VARIABLE_SCOPE ||
      variable.responseId === responseId)
  )));

/**
 * @param {String} variableId
 * @param {Immutable.Map} variables
 * @returns {Object}
 */
export const getVariableById = (variableId, variables) => flattenVariables(variables).find(
  variable => variable.id === variableId
);

/**
 * @param {String} variableId
 * @param {Immutable.Map} variables
 * @param {Boolean} onlyActive
 * @param {Boolean} includeMeta
 * @returns {Object}
 */
export function getVariable(
  variableId,
  variables,
  onlyActive = false,
  includeMeta = false
) {
  let variable = getVariableById(variableId, variables.delete("meta"));

  if (!variable && includeMeta) {
    variable = variables.get("meta").find(v => v.id === variableId);
  }

  if (onlyActive && variable && !isActive(variable)) {
    return null;
  }

  return variable;
}

/**
 * @param {Immutable.Map} variables
 * @returns {Boolean}
 */
export function noVariablesAvailable(variables) {
  if (!variables) {
    return true;
  }

  return !flattenVariables(variables).size;
}

export const varRegexp = /\{([\w]+)\|([^}]*?)\}/gi;
